export const NOTIFICATIONS_PAGE_QUERY_KEY = 'NOTIFICATIONS_PAGE_QUERY_KEY';
export const NOTIFICATIONS_QUERY_KEY = 'NOTIFICATIONS_QUERY_KEY';
export const NOTIFICATIONS_COUNT_QUERY_KEY = 'NOTIFICATIONS_COUNT_QUERY_KEY';
export const NOTIFICATIONS_TEMPORARY_QUERY_KEY = 'NOTIFICATIONS_TEMPORARY_QUERY_KEY';
export const NOTIFICATIONS_IN_APP_OBRA_QUERY_KEY = 'NOTIFICATIONS_IN_APP_OBRA_QUERY_KEY';
export const NOTIFICATIONS_IN_APP_OBRA_COUNT_QUERY_KEY = 'NOTIFICATIONS_IN_APP_OBRA_COUNT_QUERY_KEY';
export const NOTIFICATIONS_IN_APP_TOPIC_QUERY_KEY = 'NOTIFICATIONS_IN_APP_TOPIC_QUERY_KEY';
export const NOTIFICATIONS_PERSONAL_KEY = 'NOTIFICATIONS_PERSONAL_KEY';

export const GET_FILE_INFO_QUERY_KEY = 'GET_FILE_INFO_QUERY_KEY';
export const GET_FILE_HISTORY_QUERY_KEY = 'GET_FILE_HISTORY_QUERY_KEY';

export const OBRA_QUERY_KEY = 'OBRA_QUERY_KEY';
export const OBRA_FETCH_QUERY_KEY = 'OBRA_FETCH_QUERY_KEY';

export const QUERY_KEY_USERS = 'QUERY_KEY_USERS';

export const REPORT_EMAILS_QUERY_KEY = 'REPORT_EMAILS_QUERY_KEY';

export const QUERY_KEY_ACTIVITIES_UPDATED_DATE = 'QUERY_KEY_ACTIVITIES_UPDATED_DATE';

export const QUERY_KEY_ACTIVITIES_FOLLOWERS = 'QUERY_KEY_ACTIVITIES_FOLLOWERS';

export const PREFERENCES_EMAIL_QUERY_KEY = 'PREFERENCES_EMAIL_QUERY_KEY';
export const PREFERENCES_NOTIFICATIONS_QUERY_KEY = 'PREFERENCES_NOTIFICATIONS_QUERY_KEY';

export const QUERY_KEY_MOVE_FILES_LIST = 'QUERY_KEY_MOVE_FILES_LIST';

export const QUERY_KEY_ADM_TENANT_DETAILS = 'QUERY_KEY_ADM_TENANT_DETAILS';
